// Setting media at .98 because does not change media at whole pixel?
// we should import these as functions so we always have the current matchMedia value
export const smallMediaQueryList = () => {
    return window.matchMedia("(max-width: 479.98px)").matches;
};
export const mobileMediaQueryList = () => {
    return window.matchMedia("(max-width: 767.98px)").matches;
};
export const tabletMediaQueryList = () => {
    return window.matchMedia("(max-width: 1023.98px)").matches;
};
